import React from "react";
import ReactECharts from "echarts-for-react";
import moment from "moment";
import download from "./downloadCSV.jpg";

class FlowDurationChart extends React.Component {
  constructor(props) {
    super(props);
    const processedData = this.props.data.map((value) => parseFloat(value));
   const seriesData = this.props.data.map((value, index) => ({
      value,
      category: this.props.prob[index],
    }));
    this.state = {
      height: Math.min(360, window.innerHeight * 0.9), // Initial height

      option: {
  
      title: {
        text: this.props.rname[0],
        subtext: this.props.rname[1],
        left: "center",
        top: "10px",
        textStyle: {
          fontSize: 16,
          color: "#0000ff",
        },
        subtextStyle: {
          fontSize: 14,
          color: "#0000ff",
        },
      },
      toolbox: {
        feature: {
          magicType: {
            type: ["bar", "line"],
            title: {
              line: "Line Chart",
              bar: "Bar Chart",
            },
          },
          restore: {
            title: "Restore",
          },
          saveAsImage: {
            title: "Save",
            type: "png",
            name:
              this.props.rname[1]
                .split("(")[0]
                .replace(" ", "_") +
              "_FDC_" +
              this.props.date,
          },
          myExportCSV: {  // Custom CSV button
            show: true,
            title: "Export to CSV",
            icon: `image://${download}`,  // You can replace this with the path to your custom icon
            onclick: this.exportToCSV,
          },
        },
      },
      tooltip: {
        trigger: "axis",
        backgroundColor: "#333",
        borderColor: "#777",
        borderWidth: 1,
        textStyle: {
          color: "#fff",
        },
      },
      grid: {
        top: '15%',
        bottom: '20%',
        left: '10%',
        right: '0%',
      },
   
      xAxis: {
        type: "value",
        name: "Excedence Probability",
        nameLocation: "center",
        nameTextStyle: {
          fontSize: 12,
          color: '#000',       
               fontWeight:'bold',

        },
        nameGap: 20,
        min: 0,
        max: 1,
       
        axisLabel: {
          formatter: (value) => value.toFixed(2),
        },
      },
      yAxis: {
        type: "value",
        name: "Inflow (Cusecs)",
        nameLocation: "center",
        nameTextStyle: {
          fontSize: 12,
          color: '#000',       
               fontWeight:'bold',

        },
        nameGap: 55,
       
        axisLabel: {
          formatter: (value) => value.toFixed(0),
        },
      },
      grid: {
        left: "10%",
        right: "10%",
        bottom: "15%",
        top: "20%",
      },
      series: [
        {
          name: "Streamflow (ft³/s)",
          type: "line",
          data: seriesData.map((item) => [item.category, item.value]),
          smooth: true,
          symbol: "none",

          lineStyle: {
            width: 3,
            color: '#26a0fc',

          },
          emphasis: {
            focus: "series",
          },
          // markPoint: {
          //   data: [
          //     { type: "max", name: "Max" },
          //     { type: "min", name: "Min" },
          //   ],
          // },
          // markLine: {
          //   data: [
          //     { type: "average", name: "Avg" },
          //   ],
          // },
        },
      ],
      
      dataZoom: [
      
        {
          type: "inside",
        },
      ],
    }
  }
    }
    updateChartSize = () => {
      this.setState({
        height: Math.min(360, window.innerHeight * 0.9),
      });
    };
  
    componentDidMount() {
      window.addEventListener("resize", this.updateChartSize);
    }
  
    componentWillUnmount() {
      window.addEventListener("resize", this.updateChartSize);
    }
  

  exportToCSV = () => {
    const { prob, data, rname, date } = this.props;

    let csvContent = `"Probability","Streamflow (ft³/s)"\n`;
    prob.forEach((value, index) => {
      csvContent += `${value},${data[index] || ""}\n`;
    });

    const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a");
    const filename = `${rname[1]?.split("(")[0].replace(" ", "_")}_FDC_${date || moment().format("YYYY-MM-DD")}.csv`;

    a.href = URL.createObjectURL(csvBlob);
    a.download = filename;
    a.click();
  };
 

  render() {
    console.log("flowwwwwwwww",this.props.data,this.props.prob,this.processedData)
    return (
      <div>
        <ReactECharts
          option={this.state.option}
          style={{ height: '350px', width: '100%' }}
          />
      </div>
    );
  }
}

export default FlowDurationChart;
